class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.currentRadioElement = this.querySelector(".slider-dot");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.mediaGalleryHeight;
    this.sliderVertical = document
      .querySelector(".thumbnail-slider")
      .classList.contains("vertical_slider_thumb");

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    window.addEventListener("resize", this.setThubnailHeight);

    if (this.sliderVertical && window.innerWidth > 749) {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientHeight > 0
      );
      if (this.sliderItemsToShow.length < 2) return;

      this.mediaGalleryHeight = document.querySelector(
        ".product__media-gallery"
      ).clientHeight;
      this.setThubnailHeight();

      this.sliderItemOffsetY =
        this.sliderItemsToShow[1].offsetTop -
        this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPageY = Math.floor(
        this.slider.clientHeight / this.sliderItemOffsetY
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPageY + 1;
    } else {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientWidth > 0
      );
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft;

      this.slidesPerPage = Math.floor(
        this.slider.clientWidth / this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    }

    // if( !this.classList.contains('slider-mobile-gutter') ) {

    // } else {
    //   this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    //   if (this.sliderItemsToShow.length < 2) return;

    //   this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

    //   this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    //   this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    // }
    // document.getElementById('Slider-Thumbnails-template--14171455225920__main').scrollTo({ top: 0, behavior: "smooth" });

    this.update();
    setTimeout(() => {
      // this.thumbnailRadio();
    }, 1000);
  }

  updateCarousalArrow() {
    if (this.sliderVertical && window.innerWidth > 749) {
      this.slidesPerPageY;
      if (this.slidesPerPageY < this.totalPages) {
      }
      this.updateVerticalCarousalClass();
    }
  }

  setThubnailHeight() {
    // return false;
    if (window.innerWidth > 749) {
      this.mediaGalleryHeight = document.querySelector(
        ".product__media-gallery"
      ).clientHeight;
      document.querySelector(".thumbnail-list").style.height =
        this.mediaGalleryHeight - 106 + "px";
      if (document.querySelector(".bundle_variant_wrap")) {
        this.slider.scrollTo({
          top: 0,
        });
      }
    } else {
      document.querySelector(".thumbnail-list").style.removeProperty("height");
    }
  }

  thumbnailRadio() {
    var latestRadioThumb = [];
    // this.currentRadioElement.innerHTML = '';
    this.sliderItemsToShow.map((list) => {
      latestRadioThumb = list.dataset.mediaId;
    });
    this.currentRadioElement.appendChild(...this.sliderItemsToShow);
    // this.currentRadioElement.innerHTML = latestRadioThumb;
    // this.latestRadioThumb = '';
    // delete this.latestRadioThumb;
    // this.latestRadioThumb = this.sliderItemsToShow.map((list)=>{
    //   return this.latestRadioThumb + list.outerHTML;
    // })
    // this.currentRadioElement.innerHTML = this.latestRadioThumb;
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (this.sliderVertical && window.screen.width > 749) {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (element) => element.clientHeight > 0
      );
      // this.pageTotalElement = this.sliderItemsToShow.length;
    }

    const previousPage = this.currentPage;

    if (
      this.sliderVertical &&
      !this.slider.classList.contains("slider--mobile")
    ) {
      this.currentPage =
        Math.round(this.slider.scrollTop / this.sliderItemOffsetY) + 1;
    } else {
      this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    // console.clear();
    // console.log(this.sliderItemsToShow);
    // console.log(this.currentPage);
    // console.log(this.totalPages);
    // console.log(this.currentPageElement);

    // console.log('currentpae ', this.currentPage);
    // console.log('previousPage ', previousPage);
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    this.updateVerticalCarousalClass();
  }

  updateVerticalCarousalClass() {
    if (this.sliderVertical) {
      if (this.isSlideVisible(this.sliderItemsToShow[0])) {
        this.classList.remove("top-gray");
        if (this.querySelector(".slider-button--next"))
          this.querySelector(".slider-button--next").classList.remove("d-none");
        if (this.querySelector(".slider-button--prev"))
          this.querySelector(".slider-button--prev").classList.add("d-none");
      } else {
        this.classList.add("top-gray");
      }

      if (
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        )
      ) {
        this.classList.remove("bottom-gray");
        if (this.querySelector(".slider-button--next"))
          this.querySelector(".slider-button--next").classList.add("d-none");
        if (this.querySelector(".slider-button--prev"))
          this.querySelector(".slider-button--prev").classList.remove("d-none");
      } else {
        this.classList.add("bottom-gray");
      }

      if (
        this.isSlideVisible(this.sliderItemsToShow[0]) &&
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        )
      ) {
        if (this.querySelector(".slider-button--next"))
          this.querySelector(".slider-button--next").classList.add("d-none");
        if (this.querySelector(".slider-button--prev"))
          this.querySelector(".slider-button--prev").classList.add("d-none");
      }
    } else {
      if (this.isSlideVisible(this.sliderItemsToShow[0])) {
        // this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        // this.prevButton.removeAttribute('disabled');
      }

      if (
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        )
      ) {
        // this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        // this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    let lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    if (this.sliderVertical) {
      lastVisibleSlide =
        this.slider.clientHeight + this.slider.scrollTop - offset;
      return (
        element.offsetTop + element.clientHeight <= lastVisibleSlide &&
        element.offsetTop >= this.slider.scrollTop
      );
    } else {
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
        element.offsetLeft >= this.slider.scrollLeft
      );
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;

    if (this.sliderVertical) {
      this.slideScrollPositionY =
        event.currentTarget.name === "next"
          ? this.slider.scrollTop + step * this.sliderItemOffsetY
          : this.slider.scrollTop - step * this.sliderItemOffsetY;
      this.slider.scrollTo({
        top: this.slideScrollPositionY,
      });
    } else {
      this.slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
      this.slider.scrollTo({
        left: this.slideScrollPosition,
      });
    }
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);

    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);
